import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { EIcon } from '@shared/enums/icon.enum';

@Component({
  selector: 'app-empty-data',
  templateUrl: './empty-data.component.html',
  styleUrls: ['./empty-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyDataComponent extends ComponentAbstract implements OnInit {
  @Input() header = 'No data to display';
  @Input() info = 'The selected turnover does not exist, or there was an error retrieving it';
  @Input() icon: EIcon = EIcon.ERROR;

  constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit(): void {}
}
